// extracted by mini-css-extract-plugin
export default {"accordionTitle":"styles-module__accordionTitle__b88058d234ee51d10b8e"};